import { useSyncExternalStore } from "react";

const subscribeToNothing = () => () => {};

export function useClientValue<T>(
	getClientValue: () => T,
	getServerValue: () => T,
): T {
	return useSyncExternalStore(
		subscribeToNothing,
		getClientValue,
		getServerValue,
	);
}
